<template>
  <component
    :is="componentToRender"
    class="w-full py-2 px-3 flex items-center justify-between transition duration-200 ease-in-out cursor-pointer"
    :class="[ disabled ? 'cursor-default' : 'hover:bg-gray-100 dark:hover:bg-gray-950/20' ]"
    v-bind="$attrs"
    :disabled="disabled"
    :href="href"
    @click.stop.prevent="click"
  >
    <div
      class="flex items-center w-full"
      :class="{
        'opacity-50' : disabled,
        'py-2px' : !icon
      }"
    >
      <div v-if="icon" class="pr-3 leading-none" :class="colour">
        <o-icon :icon="icon" :size="iconSize" />
      </div>
      <slot name="label">
        <div class="text-left pr-2">
          <p class="text-sm leading-none" :class="colour">
            <slot>
              {{ name }}
            </slot>
          </p>
          <p v-if="description" class="text-sm opacity-60 leading-none mt-1">
            {{ description }}
          </p>
        </div>
      </slot>
    </div>
    <o-icon v-if="external" icon="externalLink" :size="12" class="opacity-60" />
  </component>
</template>

<script lang="ts">
export default { name: 'ODropdownItem' }
</script>

<script setup lang="ts">
const dropdown = inject<any>('dropdown')

interface Props {
  name?: string | null
  description?: string | number | null
  icon?: string | null
  iconSize?: number
  href?: string | null
  external?: boolean
  disabled?: boolean
  variant?: string | null
  preventDefault?: boolean
  tagName?: string
}

const props = withDefaults(defineProps<Props>(), {
  name: null,
  description: null,
  icon: null,
  iconSize: 14,
  href: null,
  external: false,
  disabled: false,
  variant: null,
  preventDefault: true,
  tagName: 'a',
})

const emit = defineEmits<{
  (e: 'click'): void
}>()

const componentToRender = computed(() => {
  if (props.href) {
    return 'a'
  }
  return props.tagName
})

const colour = computed(() => {
  switch (props.variant) {
    case 'info':
      return 'text-blue-700'
    case 'success':
      return 'text-green-700'
    case 'danger':
      return 'text-red-700'
    case 'warning':
      return 'text-yellow-700'
    default:
      return ''
  }
})

function click (e: Event) {
  if (!props.disabled) {
    emit('click')

    if (componentToRender.value === 'a' && !props.preventDefault) {
      window.open(props.href!, (props as any).target)
    }

    if (dropdown?.autoHide) {
      const closeDropdown = dropdown.closeTree || dropdown.close
      closeDropdown?.()
    }
  }
}
</script>
